import { PROGRESS } from 'config/config';
import withProgressBar from 'hoc/withProgressBar';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Caption, Container, Image, Title } from './BlikPending.styles';

class BlikPendingScreen extends PureComponent {
  render() {
    return (
      <Container className="blik-pending__container">
        <Title className="blik-pending__title">
          <h3>
            <FormattedMessage id="blikPending.title" />
          </h3>
        </Title>
        <Image className="blik-pending__icon" />
        <Caption className="blik-pending__caption">
          <FormattedMessage id="blikPending.captionMessage" />
        </Caption>
      </Container>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_PENDING)(BlikPendingScreen);
